/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { User } from '../models/user';
import { AccessAnalyzerResponse } from '../models/access-analyzer-response';
import { UserAccessToken } from '../models/user-access-token';
import { InviteUserRequest } from '../models/invite-user-request';
import { ExpandedUser } from '../models/expanded-user';
import { Role } from '../models/role';
import { Response } from '../models/response';
import { PasswordChange } from '../models/password-change';

/**
 * Ui User Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiUserControllerService extends __BaseService {
  static readonly getAllUsersUsingGETPath = '/cc-ui/v1/users/';
  static readonly analyzeAccessUsingGETPath = '/cc-ui/v1/users/analyze-access';
  static readonly createTokenUsingPOSTPath =
    '/cc-ui/v1/users/createAccessToken';
  static readonly getCurrentUserUsingGETPath = '/cc-ui/v1/users/current-user';
  static readonly inviteUsersUsingPOSTPath = '/cc-ui/v1/users/invite-users';
  static readonly getAllUsersExpandedUsingGETPath =
    '/cc-ui/v1/users/list/users-expanded';
  static readonly getALlLoggedInUsersUsingGETPath = '/cc-ui/v1/users/loggedIn';
  static readonly deleteALlLoggedInUsersUsingDELETEPath =
    '/cc-ui/v1/users/loggedIn/session';
  static readonly getAllSystemRolesUsingGETPath = '/cc-ui/v1/users/roles';
  static readonly getTokenUsingGETPath = '/cc-ui/v1/users/tokens';
  static readonly deleteTokenUsingDELETEPath =
    '/cc-ui/v1/users/tokens/{tokenId}';
  static readonly updatePasswordUsingPOSTPath =
    '/cc-ui/v1/users/updatePassword';
  static readonly getUserUsingGETPath = '/cc-ui/v1/users/{userId}';
  static readonly deleteUserUsingDELETEPath = '/cc-ui/v1/users/{userId}';
  static readonly getUserExpandedUsingGETPath =
    '/cc-ui/v1/users/{userId}/user-expanded';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllUsers
   * @return OK
   */
  getAllUsersUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<User>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<User>>;
      }),
    );
  }
  /**
   * getAllUsers
   * @return OK
   */
  getAllUsersUsingGET(): __Observable<Array<User>> {
    return this.getAllUsersUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<User>),
    );
  }

  /**
   * analyzeAccess
   * @param permissions permissions
   * @return OK
   */
  analyzeAccessUsingGETResponse(
    permissions: Array<string>,
  ): __Observable<__StrictHttpResponse<Array<AccessAnalyzerResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (permissions || []).forEach((val) => {
      if (val != null)
        __params = __params.append('permissions', val.toString());
    });
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/analyze-access`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AccessAnalyzerResponse>>;
      }),
    );
  }
  /**
   * analyzeAccess
   * @param permissions permissions
   * @return OK
   */
  analyzeAccessUsingGET(
    permissions: Array<string>,
  ): __Observable<Array<AccessAnalyzerResponse>> {
    return this.analyzeAccessUsingGETResponse(permissions).pipe(
      __map((_r) => _r.body as Array<AccessAnalyzerResponse>),
    );
  }

  /**
   * createToken
   * @param params The `UiUserControllerService.CreateTokenUsingPOSTParams` containing the following parameters:
   *
   * - `userName`:
   *
   * - `tokenId`:
   *
   * - `token`:
   *
   * - `name`:
   *
   * - `description`:
   *
   * - `createdOn`:
   *
   * @return OK
   */
  createTokenUsingPOSTResponse(
    params: UiUserControllerService.CreateTokenUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Array<UserAccessToken>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userName != null)
      __params = __params.set('userName', params.userName.toString());
    if (params.tokenId != null)
      __params = __params.set('tokenId', params.tokenId.toString());
    if (params.token != null)
      __params = __params.set('token', params.token.toString());
    if (params.name != null)
      __params = __params.set('name', params.name.toString());
    if (params.description != null)
      __params = __params.set('description', params.description.toString());
    if (params.createdOn != null)
      __params = __params.set('createdOn', params.createdOn.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/users/createAccessToken`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserAccessToken>>;
      }),
    );
  }
  /**
   * createToken
   * @param params The `UiUserControllerService.CreateTokenUsingPOSTParams` containing the following parameters:
   *
   * - `userName`:
   *
   * - `tokenId`:
   *
   * - `token`:
   *
   * - `name`:
   *
   * - `description`:
   *
   * - `createdOn`:
   *
   * @return OK
   */
  createTokenUsingPOST(
    params: UiUserControllerService.CreateTokenUsingPOSTParams,
  ): __Observable<Array<UserAccessToken>> {
    return this.createTokenUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Array<UserAccessToken>),
    );
  }

  /**
   * getCurrentUser
   * @return OK
   */
  getCurrentUserUsingGETResponse(): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/current-user`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      }),
    );
  }
  /**
   * getCurrentUser
   * @return OK
   */
  getCurrentUserUsingGET(): __Observable<User> {
    return this.getCurrentUserUsingGETResponse().pipe(
      __map((_r) => _r.body as User),
    );
  }

  /**
   * inviteUsers
   * @param inviteUserRequest inviteUserRequest
   */
  inviteUsersUsingPOSTResponse(
    inviteUserRequest: InviteUserRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = inviteUserRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/users/invite-users`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * inviteUsers
   * @param inviteUserRequest inviteUserRequest
   */
  inviteUsersUsingPOST(
    inviteUserRequest: InviteUserRequest,
  ): __Observable<null> {
    return this.inviteUsersUsingPOSTResponse(inviteUserRequest).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getAllUsersExpanded
   * @return OK
   */
  getAllUsersExpandedUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<ExpandedUser>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/list/users-expanded`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ExpandedUser>>;
      }),
    );
  }
  /**
   * getAllUsersExpanded
   * @return OK
   */
  getAllUsersExpandedUsingGET(): __Observable<Array<ExpandedUser>> {
    return this.getAllUsersExpandedUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<ExpandedUser>),
    );
  }

  /**
   * getALlLoggedInUsers
   * @return OK
   */
  getALlLoggedInUsersUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<{}>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/loggedIn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<{}>>;
      }),
    );
  }
  /**
   * getALlLoggedInUsers
   * @return OK
   */
  getALlLoggedInUsersUsingGET(): __Observable<Array<{}>> {
    return this.getALlLoggedInUsersUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<{}>),
    );
  }

  /**
   * deleteALlLoggedInUsers
   * @return OK
   */
  deleteALlLoggedInUsersUsingDELETEResponse(): __Observable<
    __StrictHttpResponse<boolean>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/users/loggedIn/session`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteALlLoggedInUsers
   * @return OK
   */
  deleteALlLoggedInUsersUsingDELETE(): __Observable<boolean> {
    return this.deleteALlLoggedInUsersUsingDELETEResponse().pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getAllSystemRoles
   * @return OK
   */
  getAllSystemRolesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<Role>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/roles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Role>>;
      }),
    );
  }
  /**
   * getAllSystemRoles
   * @return OK
   */
  getAllSystemRolesUsingGET(): __Observable<Array<Role>> {
    return this.getAllSystemRolesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<Role>),
    );
  }

  /**
   * getToken
   * @return OK
   */
  getTokenUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<UserAccessToken>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/tokens`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserAccessToken>>;
      }),
    );
  }
  /**
   * getToken
   * @return OK
   */
  getTokenUsingGET(): __Observable<Array<UserAccessToken>> {
    return this.getTokenUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<UserAccessToken>),
    );
  }

  /**
   * deleteToken
   * @param tokenId tokenId
   * @return OK
   */
  deleteTokenUsingDELETEResponse(
    tokenId?: string,
  ): __Observable<__StrictHttpResponse<Array<UserAccessToken>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (tokenId != null) __params = __params.set('tokenId', tokenId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/users/tokens/${encodeURIComponent(String(tokenId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserAccessToken>>;
      }),
    );
  }
  /**
   * deleteToken
   * @param tokenId tokenId
   * @return OK
   */
  deleteTokenUsingDELETE(
    tokenId?: string,
  ): __Observable<Array<UserAccessToken>> {
    return this.deleteTokenUsingDELETEResponse(tokenId).pipe(
      __map((_r) => _r.body as Array<UserAccessToken>),
    );
  }

  /**
   * updatePassword
   * @param updatePasswordRequest updatePasswordRequest
   * @return OK
   */
  updatePasswordUsingPOSTResponse(
    updatePasswordRequest: PasswordChange,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = updatePasswordRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/users/updatePassword`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * updatePassword
   * @param updatePasswordRequest updatePasswordRequest
   * @return OK
   */
  updatePasswordUsingPOST(
    updatePasswordRequest: PasswordChange,
  ): __Observable<Response> {
    return this.updatePasswordUsingPOSTResponse(updatePasswordRequest).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * getUser
   * @param userId userId
   * @return OK
   */
  getUserUsingGETResponse(
    userId: string,
  ): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/users/${encodeURIComponent(String(userId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      }),
    );
  }
  /**
   * getUser
   * @param userId userId
   * @return OK
   */
  getUserUsingGET(userId: string): __Observable<User> {
    return this.getUserUsingGETResponse(userId).pipe(
      __map((_r) => _r.body as User),
    );
  }

  /**
   * deleteUser
   * @param userId userId
   * @return OK
   */
  deleteUserUsingDELETEResponse(
    userId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/users/${encodeURIComponent(String(userId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteUser
   * @param userId userId
   * @return OK
   */
  deleteUserUsingDELETE(userId: string): __Observable<boolean> {
    return this.deleteUserUsingDELETEResponse(userId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getUserExpanded
   * @param userId userId
   * @return OK
   */
  getUserExpandedUsingGETResponse(
    userId: string,
  ): __Observable<__StrictHttpResponse<ExpandedUser>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/users/${encodeURIComponent(String(userId))}/user-expanded`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ExpandedUser>;
      }),
    );
  }
  /**
   * getUserExpanded
   * @param userId userId
   * @return OK
   */
  getUserExpandedUsingGET(userId: string): __Observable<ExpandedUser> {
    return this.getUserExpandedUsingGETResponse(userId).pipe(
      __map((_r) => _r.body as ExpandedUser),
    );
  }
}

module UiUserControllerService {
  /**
   * Parameters for createTokenUsingPOST
   */
  export interface CreateTokenUsingPOSTParams {
    userName?: string;
    tokenId?: string;
    token?: string;
    name?: string;
    description?: string;
    createdOn?: string;
  }
}

export { UiUserControllerService };
